import Cookies, { type CookieAttributes } from 'js-cookie';

export const getCookie = (key: string) => Cookies.get(key);

export const sanitizeCookieValue = (raw?: string | null): string => {
  if (!raw) {
    return '';
  }

  const trimmed = raw.trim();

  if (
    trimmed.length >= 2 &&
    ((trimmed.startsWith('"') && trimmed.endsWith('"')) ||
      (trimmed.startsWith("'") && trimmed.endsWith("'")))
  ) {
    return trimmed.slice(1, -1).trim();
  }

  return trimmed;
};

export const setCookie = (
  key: string,
  value: string,
  options: CookieAttributes = {},
) => {
  Cookies.set(key, value, options);
};
